import { cn } from '../../lib/cn.js';

export interface ProgressBarProps {
  /** 0–100, or null for an indeterminate (unknown) amount. */
  value: number | null;
  /** Accessible name, e.g. "Recuperación de historial". */
  label: string;
  /** Visible text next to the bar, e.g. "12 de 40 chats". Defaults to the percentage. */
  valueText?: string;
  className?: string;
}

/** Determinate/indeterminate progress bar with an accessible name and a visible value. */
export function ProgressBar({ value, label, valueText, className }: ProgressBarProps) {
  const pct = value === null ? null : Math.max(0, Math.min(100, Math.round(value)));
  const text = valueText ?? (pct === null ? 'En curso…' : `${pct}%`);
  return (
    <div className={cn('grid gap-1', className)}>
      <div
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct ?? undefined}
        aria-valuetext={text}
        className="h-2 w-full overflow-hidden rounded-pill border border-border-control bg-surface-subtle"
      >
        <div
          className={cn(
            'h-full rounded-pill bg-brand-primary transition-[width] duration-[var(--cm-motion-base)] motion-reduce:transition-none',
            pct === null && 'w-1/3 animate-pulse',
          )}
          style={pct === null ? undefined : { width: `${pct}%` }}
        />
      </div>
      <span className="cm-tabular text-helper text-text-secondary">{text}</span>
    </div>
  );
}
